var Request = require('./helper/request');

function Subscription(app){
  var self = this;
  self.request = new Request(app);

  self.routes = {
    start: {
      url: '/subscriptions/start',
      method: 'POST'
    },
    start3ds: {
      url: '/subscriptions/start/3ds',
      method: 'POST'
    },
    cancel: {
      url: '/subscriptions/cancel',
      method: 'DELETE'
    },
    list: {
      url: '/subscriptions/list',
      method: 'GET'
    }
  };
}

Subscription.prototype.start = function(data){
  var self = this;
  return self.request.post(self.routes.start.url, data);
};

Subscription.prototype.start3ds = function(data){
  var self = this;
  return self.request.post(self.routes.start3ds.url, data);
};

Subscription.prototype.cancel = function(data){
  var self = this;
  return self.request.delete(self.routes.cancel.url);
};

Subscription.prototype.list = function(id){
  var self = this;
  return self.request.get(self.routes.list.url);
}

module.exports = Subscription;